import React from 'react';
import styles from './index.module.less';
import { isDrFans } from '@/shared/app-common';
import { FacebookShareButton, TwitterShareButton } from 'react-share';
import copy from 'clipboard-copy';
import { App } from 'antd';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';

const SharePage = ({ shareUrl }: { shareUrl: string }) => {
  const { message } = App.useApp();

  const { t } = useTranslation('common');
  const twPath = isDrFans ? '/images/share/share_twitter.webp' : '/images/share/share_twitter_blank.webp';
  const copyPath = isDrFans ? '/images/share/share_copy.webp' : '/images/share/share_copy_blank.webp';

  const title = `Loving this! 🌟 Can't believe I didn't find this sooner.`;

  const handleCopyAction = async () => {
    try {
      await copy(shareUrl);
      message.success(t('URLCopiedToClipboard'));
    } catch (err) {
      console.error('Unable to copy text to clipboard:', err);
    }
  };

  return (
    <div className={styles.container}>
      <span>{t('share')}</span>

      <FacebookShareButton url={shareUrl}>
        {/* <img src='/images/share/share_fb.webp' /> */}
        <div className={styles.imgItem}>
          <Image
            src="/images/share/share_fb.webp"
            alt="Facebook Share"
            loading="lazy"
            width={28}
            height={28}
            layout="responsive"
          />
        </div>
      </FacebookShareButton>

      <TwitterShareButton title={title} url={shareUrl}>
        {/* <img src={twPath} /> */}
        <div className={styles.imgItem}>
          <Image src={twPath} alt="Twitter Share" loading="lazy" width={28} height={28} layout="responsive" />
        </div>
      </TwitterShareButton>

      {/* <img src={copyPath} onClick={handleCopyAction} /> */}
      <div className={styles.imgItem}>
        <Image
          src={copyPath}
          alt="Copy"
          loading="lazy"
          width={28}
          height={28}
          layout="responsive"
          onClick={handleCopyAction}
        />
      </div>
    </div>
  );
};

export default SharePage;
